import { c as _c } from "react/compiler-runtime";
import { Navigate, Outlet, Route, Routes, useLocation, useNavigate, useParams } from "react-router";
import { AppShell } from "@/components/layout/app-shell";
import { AuthPage } from "@/pages/auth";
import { MarketplaceListingPage } from "@/pages/marketplace-listing";
import { MarketplacePage } from "@/pages/marketplace";
import { NotFoundPage } from "@/pages/not-found";
import { OfferingDetailPage } from "@/pages/offering-detail";
import { OfferingsPage } from "@/pages/offerings";
import { PayoutsPage } from "@/pages/payouts";
import { PortfolioPage } from "@/pages/portfolio";
import { PurchasePage } from "@/pages/purchase";
import { ReferralsPage } from "@/pages/referrals";
import { SellPage } from "@/pages/sell";
import { SettingsPage } from "@/pages/settings";
import { notifications } from "@/mocks/residual";
import { useAuth } from "@/store";
const tabPaths: Record<string, string> = {
  explore: "/explore",
  market: "/market",
  portfolio: "/portfolio",
  income: "/income",
  settings: "/settings"
};
function activeTabFor(pathname: string): string {
  if (pathname.startsWith("/market")) return "market";
  if (pathname.startsWith("/portfolio")) return "portfolio";
  if (pathname.startsWith("/income")) return "income";
  if (pathname.startsWith("/settings") || pathname.startsWith("/referrals")) return "settings";
  return "explore";
}
function ShellLayout() {
  const $ = _c(9);
  const navigate = useNavigate();
  const location = useLocation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = notifications.filter(_temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const unread = t0.length;
  let t1;
  if ($[1] !== location.pathname) {
    t1 = activeTabFor(location.pathname);
    $[1] = location.pathname;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== navigate) {
    t2 = id => navigate(tabPaths[id] ?? "/");
    $[3] = navigate;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Outlet />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2) {
    t4 = <AppShell active={t1} onNavigate={t2} notificationCount={unread}>{t3}</AppShell>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp(n) {
  return !n.read;
}
function ExploreRoute() {
  const $ = _c(2);
  const navigate = useNavigate();
  let t0;
  if ($[0] !== navigate) {
    t0 = <OfferingsPage onSelect={id => navigate(`/offerings/${id}`)} />;
    $[0] = navigate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function OfferingDetailRoute() {
  const $ = _c(7);
  const navigate = useNavigate();
  const {
    id: t0
  } = useParams();
  const id = t0 === undefined ? "" : t0;
  let t1;
  let t2;
  if ($[0] !== navigate) {
    t1 = () => navigate(-1);
    t2 = oid => navigate(`/offerings/${oid}/buy`);
    $[0] = navigate;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== id || $[4] !== t1 || $[5] !== t2) {
    t3 = <OfferingDetailPage offeringId={id} onBack={t1} onBuy={t2} />;
    $[3] = id;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function PurchaseRoute() {
  const $ = _c(7);
  const navigate = useNavigate();
  const {
    id: t0
  } = useParams();
  const id = t0 === undefined ? "" : t0;
  let t1;
  let t2;
  if ($[0] !== navigate) {
    t1 = () => navigate(-1);
    t2 = () => navigate("/portfolio");
    $[0] = navigate;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== id || $[4] !== t1 || $[5] !== t2) {
    t3 = <PurchasePage offeringId={id} onBack={t1} onComplete={t2} />;
    $[3] = id;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function PortfolioRoute() {
  const $ = _c(2);
  const navigate = useNavigate();
  let t0;
  if ($[0] !== navigate) {
    t0 = <PortfolioPage onListForSale={positionId => navigate(`/portfolio/sell/${positionId}`)} onViewOffering={oid => navigate(`/offerings/${oid}`)} />;
    $[0] = navigate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function SellRoute() {
  const $ = _c(7);
  const navigate = useNavigate();
  const {
    positionId
  } = useParams();
  const t0 = positionId ?? null;
  let t1;
  let t2;
  if ($[0] !== navigate) {
    t1 = () => navigate(-1);
    t2 = () => navigate("/market");
    $[0] = navigate;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = <SellPage positionId={t0} onBack={t1} onListed={t2} />;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function MarketRoute() {
  const $ = _c(2);
  const navigate = useNavigate();
  let t0;
  if ($[0] !== navigate) {
    t0 = <MarketplacePage onSelectListing={id => navigate(`/market/${id}`)} />;
    $[0] = navigate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function MarketListingRoute() {
  const $ = _c(5);
  const navigate = useNavigate();
  const {
    id: t0
  } = useParams();
  const id = t0 === undefined ? "" : t0;
  let t1;
  if ($[0] !== navigate) {
    t1 = () => navigate("/market");
    $[0] = navigate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== id || $[3] !== t1) {
    t2 = <MarketplaceListingPage listingId={id} onBack={t1} />;
    $[2] = id;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function SettingsRoute() {
  const $ = _c(3);
  const {
    signOut
  } = useAuth();
  const navigate = useNavigate();
  let t0;
  if ($[0] !== navigate || $[1] !== signOut) {
    t0 = <SettingsPage onSignOut={() => {
      signOut();
      navigate("/auth");
    }} />;
    $[0] = navigate;
    $[1] = signOut;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function AuthRoute() {
  const $ = _c(3);
  const navigate = useNavigate();
  const {
    signIn
  } = useAuth();
  let t0;
  if ($[0] !== navigate || $[1] !== signIn) {
    t0 = <AuthPage onAuthed={() => {
      signIn({
        id: "u_self",
        name: "You"
      });
      navigate("/explore");
    }} />;
    $[0] = navigate;
    $[1] = signIn;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
export function AppRoutes() {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Route path="/auth" element={<AuthRoute />} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ShellLayout />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Route path="/" element={<Navigate to="/explore" replace={true} />} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Route path="/explore" element={<ExploreRoute />} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Route path="/offerings/:id" element={<OfferingDetailRoute />} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Route path="/offerings/:id/buy" element={<PurchaseRoute />} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Route path="/portfolio" element={<PortfolioRoute />} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Route path="/portfolio/sell" element={<SellRoute />} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Route path="/portfolio/sell/:positionId" element={<SellRoute />} />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Route path="/income" element={<PayoutsPage />} />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Route path="/market" element={<MarketRoute />} />;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Route path="/market/:id" element={<MarketListingRoute />} />;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Route path="/settings" element={<SettingsRoute />} />;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Route path="/referrals" element={<ReferralsPage />} />;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Routes>{t0}<Route element={t1}>{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}<Route path="*" element={<NotFoundPage />} /></Route></Routes>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  return t14;
}